import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-swith-currency',
  templateUrl: './swith-currency.component.html',
  styleUrls: ['./swith-currency.component.scss']
})
export class SwithCurrencyComponent extends ComponentBase implements OnInit {

  valueChange: boolean = true;

  constructor() { super() }

  ngOnInit() {
    this.valueChange = this.attribute.value!=null?true:false;
  }

  onValueChange(value: boolean) {
    this.valueChange = value;
    this.attribute.value = null;
  }

  hasValue(): boolean {
    return this.attribute.value && this.attribute.value != ""
  }
}
